__webpack_require__.p = "/chsh-game-simulator/";